import rumibg from "assets/our-work/project/rumibg.png";
import projectlogo from "assets/our-work/project/projectlogo.png";
import projectimg from "assets/our-work/project/projectimg.png";
import blackcard from "assets/our-work/impact/blackcard.png";
import bluecard from "assets/our-work/impact/bluecard.png";
import graycard from "assets/our-work/impact/graycard.png";
import redcard from "assets/our-work/impact/redcard.png";
import yellocard from "assets/our-work/impact/yellocard.png";
import aignosisbg from "assets/our-work/project/aignosisbg.png"
import indiacourtbg from "assets/our-work/project/indiacourtbg.png"
import wedmonkeybg from "assets/our-work/project/wedmonkeybg.png"
import soulsofindiabg from "assets/our-work/project/soulsofindiabg.png"
import aignosislogo from "assets/our-work/project/Aignosislogo.png"
import indiacourtlogo from "assets/our-work/project/INDIACOURTlogo.png"
import wedmonkeylogo from "assets/our-work/project/wEDMONKEYlogo.png"
import aignosisimg from "assets/our-work/project/aignosisimg.jpeg"
import wedmonkeyimg from "assets/our-work/project/wedmonkeyimg.png"
import soiimg from "assets/our-work/project/soiimg.png"
import indiacourt from "assets/our-work/project/indiacourtimg.png"
import wavybg from "assets/our-work/project/wavybg.png"
import wavylogo from "assets/our-work/project/wavvylogo.png"
import wavyimg from "assets/our-work/project/wavyimg.png"
import sithabg from "assets/our-work/project/sithabg.png"
import sithaimg from "assets/our-work/project/sithaimg.png"
import sithalogo from "assets/our-work/project/sithalogo.png"
import srappbg from "assets/our-work/project/srappbg.png"
import srappimg from "assets/our-work/project/srappimg.png"
import srapplogo from "assets/our-work/project/srapplogo.png"
import indiacourtlogo2 from "assets/our-work/project/INDIACOURTlogo.png"
import indiacourtbg2 from "assets/our-work/project/indiacourtbg2.png"
import indiacourtimg2 from "assets/our-work/project/indiacourtimg2.png"

const rrumiData = {
  header: {
    backgroundImg: rumibg,
    titleLine1: "R’RUMI",
    titleLine2: "DIAMOND"
  },
  intro: {
    heading: "Exquisite Diamond Jewelry for the Global Elite",
    description: `Rrumi Diamond is a Dubai-based luxury jewelry brand that offers an exclusive collection of high-end diamond jewelry designed for a sophisticated international clientele. With a seamless online shopping experience, the website showcases GIA-certified diamonds, bespoke designs, and timeless craftsmanship, reflecting the grandeur and elegance of the Middle East’s luxury market.`
  },
  year: "2024",
  month: "september",
  points: [
    "Brand Strategy",
    "Visual identity",
    "UI/ UX Strategy",
    "Bespoke Wordpress Site",
    "Custom Wordpress Development",
    "Wordpress Plug-In Integration",
    "Payment Gateway Integration"
  ],
  images: {
    logo: projectlogo,
    projectImg: projectimg
  },
  keyFeaturesDescription: `We adopted a strategic design and development approach by first conducting in-depth market research on Dubai’s luxury jewelry trends and the preferences of global high-net-worth individuals. This insight guided the creation of immersive wireframes and intuitive prototypes, delivering a refined shopping experience. The platform was developed using React + Node.js stack for optimal performance. Robust security measures, including SSL encryption and multi-layer authentication, were implemented to ensure user safety and fraud protection.`,
  impact: [
    {
      img: yellocard,
      value: "150,000+",
      label: "High-Net-Worth<br />Individuals Reached"
    },
    {
      img: blackcard,
      value: "60%",
      label: "Faster Checkout<br />Process"
    },
    {
      img: graycard,
      value: "50%",
      label: "Higher Engagement<br />Rate"
    },
    {
      img: redcard,
      value: "4.9",
      label: "456 reviews<br />⭐⭐⭐⭐⭐"
    },
    {
      img: bluecard,
      value: "Most",
      label: "Premium Customer<br />Retention"
    }
  ]
};

const project2 = {
  header: {
    backgroundImg: aignosisbg,
    titleLine1: "Aignosis",
    titleLine2: null
  },
  intro: {
    heading: " Smart & Fast Autism Detection for Kids",
    description: `Aignosis is a cutting-edge platform designed to detect autism in kids quickly and accurately. With an intuitive interface and expert-backed assessments, it provides fast, reliable insights for parents and caregivers. Our team delivered a complete end-to-end solution—from UI/UX design and development to branding and marketing—ensuring a seamless, impactful experience.`
  },
  year: "2024",
  month: "november",
  points: [
    "Branding",
    "Website Design",
    "UI/ UX Strategy",
    "Digital Marketing",
    "Custom Wordpress Development",
    "Social Media",
    "SEO"
  ],
  images: {
    logo: aignosislogo,
    projectImg: aignosisimg
  },
  keyFeaturesDescription: `Our design and development approach focused on user-centric research to gather key insights from parents and specialists. Multiple wireframe and prototype iterations helped reduce usability issues by 60%. The platform was built using React, Node.js, and Firebase, achieving 98% faster load times. Rigorous QA and security testing ensured a smooth deployment with zero major bugs at launch.`,
  impact: [
    {
      img: yellocard,
      value: "50,000+",
      label: "Parents Reached"
    },
    {
      img: blackcard,
      value: "85%",
      label: "Screening Accuracy"
    },
    {
      img: graycard,
      value: "35%",
      label: "Reduced Drop Off Rates"
    },
    {
      img: redcard,
      value: "4.9",
      label: "456 reviews<br />⭐⭐⭐⭐⭐"
    },
    {
      img: bluecard,
      value: "15000",
      label: "Website Visit"
    }
  ]
};

const project3 = {
  header: {
    backgroundImg: wedmonkeybg,
    titleLine1: "Wed Monkey",
    titleLine2: null
  },
  intro: {
    heading: "Your One-Stop Destination for Wedding Cards",
    description: `WedMonkey is a beautifully curated platform offering a wide range of wedding card collections to suit every style, tradition, and budget. Whether you’re looking for elegant digital invitations, traditional printed cards, or trendy modern designs, WedMonkey makes wedding card selection seamless and hassle-free.`
  },
  year: "2024",
  month: "october",
  points: [
    "Branding",
    "Website Design",
    "UI/ UX Strategy",
    "Digital Marketing",
    "Custom Wordpress Development",
    "Social Media",
    "SEO"
  ],
  images: {
    logo: wedmonkeylogo,
    projectImg: wedmonkeyimg
  },
  keyFeaturesDescription: `Our strategic design and development approach has played a key role in enhancing user experience and driving sales growth. By integrating a seamless customization tool, digital & print options, and vendor discounts, we created an intuitive and engaging platform. Backed by user research, a robust tech stack, and effective branding, our solutions streamlined the ordering process, increased customer engagement, and ultimately led to higher conversions.`,
  impact: [
    {
      img: yellocard,
      value: "30,000+",
      label: "User reached through organic and paid promotion"
    },
    {
      img: blackcard,
      value: "60%",
      label: "Faster Checkout Process"
    },
    {
      img: graycard,
      value: "50%",
      label: "Higher Engagement – Due to an intuitive, visual-first experience"
    },
    {
      img: redcard,
      value: "4.9",
      label: "456 reviews<br />⭐⭐⭐⭐⭐"
    },
    {
      img: bluecard,
      value: "Top 5",
      label: "Google Search Ranking – For digital wedding invitations."
    }
  ]
};

const project4 = {
  header: {
    backgroundImg: indiacourtbg,
    titleLine1: "India Court",
    titleLine2: null
  },
  intro: {
    heading: " Free Legal Education & Lawyer Services Platform ",
    description: `India Court is a comprehensive legal platform offering free law education, legal assistance, and essential lawyer services for anyone facing legal issues. Whether you need expert legal advice, document verification, case law references, or direct lawyer consultations, India Court provides a one-stop solution to make legal help accessible and hassle-free.`
  },
  year: "2024",
  month: "december",
  points: [
    "Branding",
    "Website Design",
    "UI/ UX Strategy",
    "Digital Marketing",
    "Custom Wordpress Development",
    "Social Media",
    "SEO"
  ],
  images: {
    logo: indiacourtlogo,
    projectImg: indiacourt
  },
  keyFeaturesDescription: `Our design and development approach focused on creating a simple and user-friendly interface tailored for legal users. The platform was built using React, Node.js, and Firebase to ensure high performance and fast load times. Robust security protocols were implemented to protect sensitive legal data and maintain user trust through rigorous testing and data protection measures.`,
  impact: [
    {
      img: yellocard,
      value: "85,000+",
      label: "High-Net-Worth<br />Individuals Reached"
    },
    {
      img: blackcard,
      value: "85%",
      label: "Faster legal assesment"
    },
    {
      img: graycard,
      value: "65%",
      label: "Higher accessibility"
    },
    {
      img: redcard,
      value: "4.9",
      label: "456 reviews<br />⭐⭐⭐⭐⭐"
    },
    {
      img: bluecard,
      value: "Top 10",
      label: "GOOGLE SEARCH RANKING"
    }
  ]
};

const project5 = {
  header: {
    backgroundImg: soulsofindiabg,
    titleLine1: "Souls Of Inida",
    titleLine2: null
  },
  intro: {
    heading: "A Journey Through Culture, Craft & Conscious Living",
    description: `Souls of India is a storytelling-driven e-commerce platform that celebrates India’s rich cultural heritage, mindful living, and artisanal craftsmanship. The website showcases handcrafted products, traditional art forms, and soulful stories of Indian artisans—bringing conscious commerce and cultural storytelling together on one platform.`
  },
  year: "2024",
  month: "september",
  points: [
    "Branding",
    "Website Design",
    "UI/ UX Strategy",
    "Digital Marketing",
    "Custom Wordpress Development",
    "Social Media",
    "SEO"
  ],
  images: {
    logo: projectlogo,
    projectImg: soiimg
  },
  keyFeaturesDescription: `Our approach centered on crafting an emotionally engaging and culturally grounded interface that resonated with the essence of Indian heritage and conscious consumerism. We blended intuitive navigation with subtle storytelling elements, allowing users to effortlessly explore traditional crafts and connect with artisans on a deeper level. The design paid close attention to every detail—from typography choices to thoughtfully designed micro-interactions—all curated to evoke authenticity and warmth. Built with performance and scalability in mind, the platform ensures a seamless and enriching shopping experience that bridges tradition with modern e-commerce expectations.`,
  impact: [
    {
      img: yellocard,
      value: "2x",
      label: "User Engagement"
    },
    {
      img: blackcard,
      value: "35%",
      label: "Boost in conversion"
    },
    {
      img: graycard,
      value: "80%",
      label: "Mobile traffic optimized"
    },
    {
      img: redcard,
      value: "4.9",
      label: "456 reviews<br />⭐⭐⭐⭐⭐"
    },
    {
      img: bluecard,
      value: "great",
      label: "stronger arstiasan visibility"
    }
  ]
};
const project6 = {
  header: {
    backgroundImg: wavybg,
    titleLine1: "Wavvy",
    titleLine2: null
  },
  intro: {
    heading: "Elevating Salon & Beauty Experiences ",
    description: `Wavyy is a cutting-edge salon booking app designed for effortless appointment scheduling and seamless beauty service access. Tailored for modern users, Wavvy goes beyond just bookings—creating an engaging digital space for salons, spas, and dermatologists to showcase their expertise, interact with clients, and build a thriving beauty community.`
  },
  year: "2024",
  month: "september",
  points: [
    "Branding",
    "Website Design",
    "UI/ UX Strategy",
    "Digital Marketing",
    "Custom Wordpress Development",
    "Social Media",
    "SEO"
  ],
  images: {
    logo: wavylogo,
    projectImg: wavyimg
  },
  keyFeaturesDescription: `Our design and development approach was rooted in user-centric research, focusing on understanding user behavior to craft a frictionless booking experience. We designed an engaging and intuitive interface through iterative wireframing and prototyping, ensuring ease of use for both service providers and customers. The app was built using React Native and Firebase, enabling smooth cross-platform performance. To elevate user delight and interaction, we thoughtfully incorporated micro-interactions and animations, making the overall experience more dynamic and enjoyable.`,
  impact: [
    {
      img: yellocard,
      value: "2x",
      label: "User Engagement"
    },
    {
      img: blackcard,
      value: "35%",
      label: "Boost in conversion"
    },
    {
      img: graycard,
      value: "80%",
      label: "Mobile traffic optimized"
    },
    {
      img: redcard,
      value: "4.9",
      label: "456 reviews<br />⭐⭐⭐⭐⭐"
    },
    {
      img: bluecard,
      value: "great",
      label: "stronger arstiasan visibility"
    }
  ]
};
const project7 = {
  header: {
    backgroundImg: sithabg,
    titleLine1: "Sitha",
    titleLine2: null
  },
  intro: {
    heading: "Empowering Women Through Skill-Based Services",
    description: `Sitha is a purpose-driven gig marketplace platform exclusively built for women service providers to offer their expertise—ranging from home services to wellness and creative skills. Designed for inclusivity and accessibility, the app allows customers of all genders to discover, book, and engage with women-led services across multiple cities, while offering partners a flexible, empowering way to grow their careers.`
  },
  year: "2024",
  month: "september",
  points: [
    "Branding",
    "Website Design",
    "UI/ UX Strategy",
    "Digital Marketing",
    "Custom Wordpress Development",
    "Social Media",
    "SEO"
  ],
  images: {
    logo: sithalogo,
    projectImg: sithaimg
  },
  keyFeaturesDescription: `Our design and development approach for the Sitha App was deeply rooted in user-centric research, focusing on understanding both customer and partner behaviors to streamline the booking experience and onboarding journey. Through detailed wireframing and prototyping, we created engaging mobile interfaces tailored for ease of use and visual appeal. The platform was built using React Native, Firebase, and Node.js, ensuring high performance and seamless cross-platform functionality. To elevate user experience, we incorporated thoughtful micro-interactions and animations, making daily actions feel smooth, intuitive, and delightfully engaging.`,
  impact: [
    {
      img: yellocard,
      value: "2x",
      label: "User Engagement"
    },
    {
      img: blackcard,
      value: "35%",
      label: "Boost in conversion"
    },
    {
      img: graycard,
      value: "80%",
      label: "Mobile traffic optimized"
    },
    {
      img: redcard,
      value: "4.9",
      label: "456 reviews<br />⭐⭐⭐⭐⭐"
    },
    {
      img: bluecard,
      value: "great",
      label: "stronger arstiasan visibility"
    }
  ]
};
const project8 = {
  header: {
    backgroundImg: srappbg,
    titleLine1: "SR App",
    titleLine2: null
  },
  intro: {
    heading: "Smart School Management for Parents, Teachers & Administration",
    description: `SR App is an all-in-one school management platform designed to streamline communication and operations for parents, teachers, and school management. With a user-friendly interface, it simplifies attendance tracking, announcements, homework updates, fee payments, and student progress monitoring—all in one place.`
  },
  year: "2024",
  month: "september",
  points: [
    "Branding",
    "Website Design",
    "UI/ UX Strategy",
    "Digital Marketing",
    "Custom Wordpress Development",
    "Social Media",
    "SEO"
  ],
  images: {
    logo: srapplogo,
    projectImg: srappimg
  },
  keyFeaturesDescription: `Our design and development approach focused on creating a high-usability experience for both mobile and web platforms. We began by designing intuitive wireframes and prototypes that addressed the needs of parents, teachers, and administrators. The app was built using React Native, Node.js, and Firebase, ensuring fast performance and scalability across devices. Through extensive quality assurance and testing, we achieved a smooth deployment with zero major bugs at launch. Additionally, we developed a trustworthy and professional visual brand identity that resonated with users and enhanced overall credibility.`,
  impact: [
    {
      img: yellocard,
      value: "2x",
      label: "User Engagement"
    },
    {
      img: blackcard,
      value: "35%",
      label: "Boost in conversion"
    },
    {
      img: graycard,
      value: "80%",
      label: "Mobile traffic optimized"
    },
    {
      img: redcard,
      value: "4.9",
      label: "456 reviews<br />⭐⭐⭐⭐⭐"
    },
    {
      img: bluecard,
      value: "great",
      label: "stronger arstiasan visibility"
    }
  ]
};
const project9 = {
  header: {
    backgroundImg: indiacourtbg2,
    titleLine1: "Indiacourt",
    titleLine2: null
  },
  intro: {
    heading: "Smart School Management for Parents, Teachers & Administration",
    description: `India Court is a comprehensive legal platform offering free law education, legal assistance, and essential lawyer services for anyone facing legal issues. Whether you need expert legal advice, document verification, case law references, or direct lawyer consultations, India Court provides a one-stop solution to make legal help accessible and hassle-free.`
  },
  year: "2024",
  month: "september",
  points: [
    "Branding",
    "Website Design",
    "UI/ UX Strategy",
    "Digital Marketing",
    "Custom Wordpress Development",
    "Social Media",
    "SEO"
  ],
  images: {
    logo: indiacourtlogo2,
    projectImg: indiacourtimg2
  },
  keyFeaturesDescription: `Our design and development approach focused on creating a high-usability experience for both mobile and web platforms. We began by designing intuitive wireframes and prototypes that addressed the needs of parents, teachers, and administrators. 

The app was built using React Native, Node.js, and Firebase, ensuring fast performance and scalability across devices. Through extensive quality assurance and testing, we achieved a smooth deployment with zero major bugs at launch. Additionally, we developed a trustworthy and professional visual brand identity that resonated with users and enhanced overall credibility.`,
  impact: [
    {
      img: yellocard,
      value: "2x",
      label: "User Engagement"
    },
    {
      img: blackcard,
      value: "35%",
      label: "Boost in conversion"
    },
    {
      img: graycard,
      value: "80%",
      label: "Mobile traffic optimized"
    },
    {
      img: redcard,
      value: "4.9",
      label: "456 reviews<br />⭐⭐⭐⭐⭐"
    },
    {
      img: bluecard,
      value: "great",
      label: "stronger arstiasan visibility"
    }
  ]
};

export const allProjects = {
    rrumi: rrumiData,
    aignosis: project2,
    wedmonkey: project3,
    indiacourt: project4,
    soulsofindia: project5,
    wavvy: project6,
    sitha: project7,
    srapp: project8,
    indiacourt1: project9
  };
